import { Component, effect, inject, input, untracked } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { PendingVisitTableModel } from 'src/app/models/tables/preliminaries/pending-visit-table.model';
import { VisitTableModel } from 'src/app/models/tables/preliminaries/visit-table.model';
import { VisitService } from 'src/app/services/preliminaries/visit.service';

@Component({
  selector: 'app-pending-executed-visit',
  templateUrl: './pending-executed-visit.component.html',
  styleUrls: ['./pending-executed-visit.component.scss'],
  standalone: false
})
export class PendingExecutedVisitComponent {

  private readonly router = inject(Router);
  private readonly visitService = inject(VisitService);

  clientId = input<number | null>(null);

  ascendant: boolean = true;
  columnSort: string | null = null;
  data: PagedResponseModel<PendingVisitTableModel> = new PagedResponseModel<PendingVisitTableModel>();
  header: ColumnResponseModel[] = [];
  limit: number = 10;
  page: number = 1;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    }
  ];

  constructor() {
    effect(() => {
      this.clientId();
      untracked(() => {
        this.page = 1;
        void this.getAllPendingVisitsWithPagination();
      });
    });
  }

  async ngOnInit() {
    await this.getColumnsForPendingVisits();
  }

  async getAllPendingVisitsWithPagination() {
    try {
      this.data = await firstValueFrom(
        this.visitService.getAllPendingVisitsWithPagination(this.clientId(), this.page, this.limit, this.columnSort, this.ascendant)
      );
    } catch (error) {
      console.error('Error al buscar las visitas pendientes.', error);
    }
  }

  async getColumnsForPendingVisits() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(this.visitService.getColumnsForPendingVisits());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta de las visitas pendientes.', error);
    }
  }

  onAction(event: { action: string, item?: VisitTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/executed-visit/register/${event.item.id}`]);
    }
  }

  async onPageChange(event: { page: number; pageSize: number; sortField?: string; sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField ?? null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllPendingVisitsWithPagination();
  }

}
